import React from 'react';

const Subjects = () => (
  <div style={{ padding: 32 }}>
    <h1>My Subjects</h1>
    <p>This is the Subjects page for students.</p>
  </div>
);

export default Subjects;
